<!-- navbar-->
<header class="navbar navbar-expand-lg navbar-light">
	<div class="container">
		<a
			class="navbar-brand"
			routerLink="/"
		>
			<img
				src="image/logo-homAI-full.png"
				alt="HomAI Logo"
				height="70"
				
			/>
		</a>
		<button
			class="navbar-toggler"
			type="button"
			(click)="closeNavbar()"
		>
			<span class="navbar-toggler-icon"></span>
		</button>
		<div
			class="collapse navbar-collapse"
			id="navbarNav"
		>
			<ul class="navbar-nav ms-auto">
				@for (item of displayMenuItems(); track item.label) {
					<li>
						@if (!item.isButton && !item.dropDown && !item.disabled) {
							<a
								class="nav-link cursor-pointer"
								[routerLink]="item.link"
								>{{ item.label }}</a
							>
						}
						@if (item.isButton && !item.dropDown && !item.disabled) {
							<a
								class="btn btn-hm-primary"
								(click)="openMethod(item)"
								[routerLink]="item.link"
							>
								{{ item.label }}</a
							>
						}
						@if (item.isButton && item.dropDown && deviceType == 'desktop' && !item.disabled) {
							<div class="dropdown">
								<button
									class="btn btn-hm-primary dropdown-toggle"
									type="button"
									data-bs-toggle="dropdown"
									aria-expanded="false"
								>
									{{ item.label }}
								</button>
								<ul class="dropdown-menu cursor-pointer ul-dropdown">
									@for (section of menuDropdown; track section.label) {
										<li class="cursor-pointer">
											<a
												style="cursor: pointer !important; font-weight: 500"
												class="nav-link"
												[routerLink]="section.link"
												>{{ section.label }}</a
											>
											<hr
												class="dropdown-divider"
												style="margin-bottom: 0"
											/>
										</li>
									}
								</ul>
							</div>
						} @else if (item.isButton && item.dropDown && deviceType == 'tablet' && !item.disabled) {
							<div style="display: flex; justify-content: center; width: 100%;color:#3369FF; margin-bottom: 0;">
								<p>Area Riservata</p>
							</div>
							<hr  style="margin: 0; padding: 0;" class="divider" />
							@for (section of menuDropdown; track section.label) {
								<li class="cursor-pointer">
									<a
										style="cursor: pointer !important; font-size: 14px;"
										class="nav-link"
										[routerLink]="section.link"
										>{{ section.label }}</a
									>
									<hr
										class="dropdown-divider"
										style="margin-bottom: 0"
									/>
								</li>
							}
						}
					</li>
				}
			</ul>
		</div>
	</div>
</header>

<app-modal-login></app-modal-login>
<app-modal-generic></app-modal-generic>
